import React, {useContext, useEffect} from "react";
import {v4} from "uuid";

const defaultValue = {
    tableId: v4(),
    queryModel: {
        filter: {},
        paginationQuery: {
            pageNumber: 1,
            pageSize: 10
        },
        orderByItems: [],
        updateKey: ''
    },
    defaultFilter: {},
    selectedRows: [],
    expandedRowKeys: [],
    data: [],
    pagination: {

    },
    // Sayım artık grid cevabında gelmiyor (TotalRecords = -1): ayrı istekle, sayfa geldikten SONRA alınır.
    // Grid sorgusu her atıldığında sayaç da yeniden atılır — veri anlık değişiyor, eski toplamı göstermek yanlış.
    // key: sayımın ait olduğu filtre imzası — yalnızca geç kalmış cevabı elemek ve önceki değeri
    //      ekranda tutup tutmamaya karar vermek için (bkz. COUNT_RESULT / loadCount).
    // capped: sunucu sayımı tavanda kesti (gerçek sayı daha büyük) → "500+" gösterilir.
    // exact: kullanıcı bu filtre için "gerçek sayıyı getir" dedi → sonraki sayımlar da kesin yapılır.
    // fetcher: aynı sorgunun sayacını yeniden çağıran fonksiyon; "gerçek sayıyı getir" butonu bunu exact=true ile kullanır.
    count: {
        key: null,
        value: null,
        capped: false,
        loading: false,
        exact: false,
        fetcher: null
    },
    focusOut: null,
    // Grid'in KENDİ yükleme durumu. Tam ekran karartma yerine tablo kendi içinde soluklaşır,
    // sayfanın geri kalanı (filtre paneli, menü) kullanılabilir kalır. Veriyi çeken bileşen
    // (StudyGrid/ReportGrid) setLoading ile yönetir; kimse yönetmezse grid eskisi gibi davranır.
    loading: false,
    dataGridProps: {
        rowKey: 'id',
        columns: [],
        enableRowSelection: false,
        expandedRowRender: () => {},
        rowExpandable: false,
        antdTableProps: {},
        rowClassName: () => {},
        onRow: (record) => {}
    },
    renderItem: {
        recordId: '',
        key: ''
    }
}

export const DataGridActions = {
    ON_DEFAULT_FILTER: 'ON_DEFAULT_FILTER',
    ON_FILTER_PAGE_SORT: 'ON_FILTER_PAGE_SORT',
    ON_SELECTED_ROWS: 'ON_SELECTED_ROWS',
    SET_DATA: 'SET_DATA',
    SET_PAGINATION_RESULT: 'SET_PAGINATION_RESULT',
    SET_DATA_GRID_PROPS: 'SET_DATA_GRID_PROPS',
    RENDER_EXPANDED_ROW: 'RENDER_EXPANDED_ROW',
    SET_EXPANDED_ROW_KEYS: 'SET_EXPANDED_ROW_KEYS',
    REFRESH_DATA_GRID: 'REFRESH_DATA_GRID',
    FOCUS_OUT: 'FOCUS_OUT',
    COUNT_START: 'COUNT_START',
    COUNT_RESULT: 'COUNT_RESULT',
    SET_LOADING: 'SET_LOADING'

}

const DataGridContext = React.createContext(defaultValue)

function dataGridReducer(state, action)
{
    switch (action.type)
    {
        case DataGridActions.FOCUS_OUT: {
            return {
                ...state,
                focusOut: v4()
            }
        }
        case DataGridActions.ON_FILTER_PAGE_SORT: {
            let _state = {
                ...state
            };

            _state.selectedRows = []

            _state.queryModel.updateKey = v4();
            if(action.filter) {
                _state.queryModel.filter = {
                    ...action.filter
                }
            }

            // Sıralama (orderByItems) yalnızca çağıran AÇIKÇA geçtiğinde değişir.
            // Başlıktan sıralama (DataGrid.onChange) daima orderByItems geçer —
            // sıralama kaldırıldığında [] geçer ve [] truthy olduğu için o yol net kalır.
            // Filtre/arama formları (StudyFilter/ReportFilter) orderByItems geçmez:
            // kullanıcının uyguladığı sıralama yeni aramada KORUNUR (eskiden [] ile sıfırlanıyordu).
            if(action.orderByItems) {
                _state.queryModel.orderByItems = action.orderByItems
            }

            if(action.pagination) {
                _state.queryModel.paginationQuery = {
                    ...action.pagination
                }
            }

            if(!action.pagination && action.filter) {
                _state.queryModel.paginationQuery = {
                    pageNumber: 1,
                    pageSize: state.queryModel.paginationQuery.pageSize
                }
            }

            return _state
        }
        case DataGridActions.ON_DEFAULT_FILTER: {
            return {
                ...state,
                defaultFilter: action.defaultFilter
            }
        }
        case DataGridActions.ON_SELECTED_ROWS: {
            return {
                ...state,
                selectedRows: action.selectedRows
            }
        }
        case DataGridActions.SET_DATA: {
            return {
                ...state,
                data: action.data
            }
        }
        case DataGridActions.SET_LOADING: {
            if (state.loading === action.loading)
                return state

            return {
                ...state,
                loading: action.loading
            }
        }
        case DataGridActions.SET_PAGINATION_RESULT: {
            return {
                ...state,
                pagination: action.pagination
            }
        }
        case DataGridActions.COUNT_START: {
            return {
                ...state,
                count: {
                    key: action.key,
                    // Aynı filtre yeniden sayılıyorsa eldeki değeri ekranda tut: yeni sayı gelene kadar
                    // toplam boşalıp sayfalama zıplamasın. Filtre değiştiyse eski sayı anlamsız, sıfırlanır.
                    value: action.keepValue ? state.count.value : null,
                    capped: action.keepValue ? state.count.capped : false,
                    loading: true,
                    exact: !!action.exact,
                    fetcher: action.fetcher ?? state.count.fetcher
                }
            }
        }
        case DataGridActions.COUNT_RESULT: {
            // Geç kalmış cevap: filtre bu arada değiştiyse (key tutmuyorsa) yok say.
            if (state.count.key !== action.key)
                return state

            return {
                ...state,
                count: {
                    ...state.count,
                    value: action.value,
                    capped: action.capped,
                    loading: false
                }
            }
        }
        case DataGridActions.SET_DATA_GRID_PROPS: {
            return {
                ...state,
                dataGridProps: action.dataGridProps
            }
        }
        case DataGridActions.RENDER_EXPANDED_ROW: {
            return {
                ...state,
                renderItem: {
                    recordId: action.recordId,
                    key: v4()
                }
            }
        }
        case DataGridActions.REFRESH_DATA_GRID: {
            return {
                ...state,
                queryModel: {
                    ...state.queryModel,
                    updateKey: v4()
                }
            }
        }
        default: {
            return defaultValue
        }
    }
}

// Başlıktan seçilen sıralama tarayıcıda saklanır (yalnız sortStorageKey verilen grid'lerde):
// sayfa yenilenince / yeniden açılınca aynı sırayla gelir. Yalnız {name, operation} tutulur.
const sortStorageKeyOf = (key) => `data-grid-${key}-sort`;

function readSavedSort(key) {
    if (!key)
        return null;
    try {
        const items = JSON.parse(localStorage.getItem(sortStorageKeyOf(key)) || 'null');
        return Array.isArray(items)
            ? items.filter(x => typeof x?.name === 'string' && typeof x?.operation === 'number')
            : null;
    } catch {
        return null;
    }
}

function writeSavedSort(key, items) {
    try {
        if (items.length)
            localStorage.setItem(sortStorageKeyOf(key), JSON.stringify(items.map(({name, operation}) => ({name, operation}))));
        else
            localStorage.removeItem(sortStorageKeyOf(key));
    } catch {
        // Depolama kapalı/dolu: sıralama yalnız bu sayfa açıkken geçerli kalır.
    }
}

function DataGridProvider({children, name, defaultFilter, onRefresh, sortStorageKey})
{
    const [dataGrid, baseDispatch] = React.useReducer(dataGridReducer, null, () => ({
        ...defaultValue,
        tableId: v4(),
        queryModel: {
            ...defaultValue.queryModel,
            filter: defaultFilter || {},
            orderByItems: readSavedSort(sortStorageKey) || [],
        },
        defaultFilter: defaultFilter || {}
    }));

    // Let a parent react when this grid is refreshed (e.g. a nested detail grid
    // whose mutations should also refresh the outer grid). Kept in a ref so the
    // wrapped dispatch stays stable.
    //
    // notifyParent === false ise dış grid'e HABER VERİLMEZ. Ayrım şart: iç grid'in tazeleme
    // düğmesi yalnız kendi tablosunu yenilemeli — hiçbir şey değişmediği hâlde dıştaki study
    // grid'ini de yeniden yüklüyordu. Dış grid'i tazelemek yalnız iç grid'de VERİ DEĞİŞTİREN
    // işlemlerin (istem silme, rapor onayı…) hakkı.
    const onRefreshRef = React.useRef(onRefresh);
    onRefreshRef.current = onRefresh;
    const sortStorageKeyRef = React.useRef(sortStorageKey);
    sortStorageKeyRef.current = sortStorageKey;
    const dispatch = React.useCallback((action) => {
        if (action?.type === DataGridActions.REFRESH_DATA_GRID && action.notifyParent !== false && onRefreshRef.current) {
            onRefreshRef.current();
        }
        // Sıralama yalnız orderByItems açıkça geçildiğinde değişir (bkz. reducer); saklama da o an yapılır.
        if (action?.type === DataGridActions.ON_FILTER_PAGE_SORT && action.orderByItems && sortStorageKeyRef.current) {
            writeSavedSort(sortStorageKeyRef.current, action.orderByItems);
        }
        baseDispatch(action);
    }, []);

    const value = {dataGrid, dispatch, sortStorageKey};

    return (
        <DataGridContext.Provider value={value}>
            {children}
        </DataGridContext.Provider>
    )
}

function useDataGrid()
{
    const context = React.useContext(DataGridContext);

    if(!context)
        throw new Error('Data HospitalDashboardGrid Provider Error')

    const {dataGrid, dispatch, sortStorageKey} = context;

    const onFilterPageSort = ({filter, pagination, orderByItems}) => {
        dispatch({
            type: DataGridActions.ON_FILTER_PAGE_SORT,
            filter,
            orderByItems,
            pagination
        })
    }

    const setSelectedRows = (selectedRows) => {
        dispatch({
            type: DataGridActions.ON_SELECTED_ROWS,
            selectedRows
        })
    }

    const setData = (data) => {
        dispatch({
            type: DataGridActions.SET_DATA,
            data
        })
    }

    const setLoading = (loading) => {
        dispatch({
            type: DataGridActions.SET_LOADING,
            loading
        })
    }

    const setDataGridProps = ({rowKey, columns, rowExpandable, expandedRowRender, enableRowSelection, antdTableProps, rowClassName, onRow, virtual, virtualRowHeight}) => {
        dispatch({
            type: DataGridActions.SET_DATA_GRID_PROPS,
            dataGridProps: {
                ...dataGrid.dataGridProps,
                rowKey,
                columns,
                enableRowSelection,
                antdTableProps,
                rowExpandable,
                expandedRowRender,
                rowClassName,
                onRow,
                virtual,
                virtualRowHeight
            }
        })
    }

    const setPaginationResult = (pagination) => {
        dispatch({
            type: DataGridActions.SET_PAGINATION_RESULT,
            pagination
        })
    }

    // Sayaç isteği. fetcher(exact) → {success, data: {count, isCapped}}.
    // Grid cevabı geldikten SONRA çağrılır (sayfayı bloklamaz) ve HER çağrıldığında sayar:
    // sayfa/sıra değişse bile veri o arada değişmiş olabilir, eski toplamı göstermek yanlış.
    const loadCount = async (fetcher, key) => {
        const sameFilter = dataGrid.count.key === key
        // Kullanıcı bu filtre için kesin sayı istediyse sonraki sayımlarda da kesin say,
        // yoksa sayfa değiştirir değiştirmez "500+"a geri düşerdi.
        const exact = sameFilter && dataGrid.count.exact

        dispatch({type: DataGridActions.COUNT_START, key, fetcher, exact, keepValue: sameFilter})

        const response = await fetcher(exact)
        if (!response?.success)
            return

        dispatch({
            type: DataGridActions.COUNT_RESULT,
            key,
            value: response.data?.count ?? 0,
            capped: !!response.data?.isCapped
        })
    }

    // "Gerçek sayıyı getir": tavanlı sayım yerine tam COUNT. Aynı sorgunun fetcher'ı yeniden kullanılır.
    const loadExactCount = async () => {
        const {fetcher, key} = dataGrid.count
        if (!fetcher)
            return

        dispatch({type: DataGridActions.COUNT_START, key, fetcher, exact: true, keepValue: true})

        const response = await fetcher(true)
        if (!response?.success)
            return

        dispatch({
            type: DataGridActions.COUNT_RESULT,
            key,
            value: response.data?.count ?? 0,
            capped: false
        })
    }

    const renderExpandedRow = (recordId) => {
        dispatch({
            type: DataGridActions.RENDER_EXPANDED_ROW,
            recordId
        })
    }

    /**
     * Grid'i yeniden yükler.
     * options.notifyParent === false → yalnız BU grid yenilenir; iç içe grid'lerde dıştaki
     * grid'e (DataGridProvider onRefresh) haber gitmez. Tazeleme düğmesi bunu kullanır.
     * Varsayılan (parametresiz veya olay nesnesiyle çağrıldığında) eski davranış: dış grid de tazelenir.
     */
    const refreshDataGrid = (options) => {
        dispatch({
            type: DataGridActions.REFRESH_DATA_GRID,
            notifyParent: options?.notifyParent !== false
        })
    }

    const focusOut = () => {
        dispatch({
            type: DataGridActions.FOCUS_OUT,
        })
    }

    const setRowColor = (id, color) => {
        const table = document.getElementById(dataGrid.tableId);
        if(table)
        {
            let row = table.querySelectorAll(`[data-row-key="${id}"]`)[0];
            let tmp = document.createElement('div');

            // tmp.style.backgroundColor = color;
            // if(row.style.backgroundColor === tmp.style.backgroundColor)
            // {
            //     color = ''
            // }

            let rows = table.querySelectorAll(`[data-row-key]`);
            rows.forEach(r => {
                r.style.backgroundColor = ''
                if(r?.cells?.length > 0) {
                    r.cells[0].style.backgroundColor = ''
                }
            })

            // if(row?.cells?.length > 0) {
            //     const css = window.getComputedStyle(row);
            //     const color = css.getPropertyValue( "background-color" );
            //     row.cells[0].style.backgroundColor = color
            // }
            if(row && row.style)
                row.style.backgroundColor = color
        }

    }

    return {
        tableId: dataGrid.tableId,
        queryModel: dataGrid.queryModel,
        defaultFilter: dataGrid.defaultFilter,
        sortStorageKey,
        resultModel: {
            pagination: dataGrid.pagination,
            data: dataGrid.data,
        },
        count: dataGrid.count,
        loading: dataGrid.loading,
        setLoading,
        loadCount,
        loadExactCount,
        dataGridProps: dataGrid.dataGridProps,
        selectedRows: dataGrid.selectedRows,
        renderItem: dataGrid.renderItem,
        onFilterPageSort,
        setSelectedRows,
        setData,
        setPaginationResult,
        setDataGridProps,
        renderExpandedRow,
        refreshDataGrid,
        setRowColor,
        focusOut,
        onFocusOut: dataGrid.focusOut
    }
}

/**
 * Sayfalama için toplam kayıt sayısı. İki kaynak vardır:
 *  - Klasik grid'ler: sayım grid cevabında gelir (pagination.totalRecords >= 0).
 *  - Study/Report/HL7: sayım ayrı istekte gelir; grid cevabı totalRecords = -1 döner (bkz. ToDataGridWithoutCount).
 * Sayım gelmeden ya da tavanda kesilmişken ("500+") sayfalama kilitlenmesin diye "en az bu kadar
 * kayıt var" değeriyle taban çekilir: sayfa doluysa bir sonraki sayfa varsayılır.
 */
function getGridTotal(resultModel, count)
{
    const serverTotal = resultModel?.pagination?.totalRecords ?? 0;
    const deferred = serverTotal < 0;

    if(!deferred)
        return {total: serverTotal, deferred: false, capped: false, loading: false}

    const pageSize = resultModel?.pagination?.pageSize || 10;
    const pageNumber = resultModel?.pagination?.pageNumber || 1;
    const rowCount = resultModel?.data?.length ?? 0;
    const atLeast = (pageNumber - 1) * pageSize + rowCount + (rowCount === pageSize ? 1 : 0);

    return {
        total: Math.max(count?.value ?? 0, atLeast),
        deferred: true,
        capped: !!count?.capped,
        loading: !!count?.loading,
        known: count?.value !== null && count?.value !== undefined
    }
}

export {DataGridProvider, useDataGrid, getGridTotal}
